import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function useLogout() {
  const setLogined = Recoil.useSetRecoilState(AppStore.app.logined);
  const setDoctorInfo = Recoil.useSetRecoilState(AppStore.assets.doctor_info);
  const setPatientList = Recoil.useSetRecoilState(AppStore.assets.patient_list);
  const setPatientHash = Recoil.useSetRecoilState(AppStore.assets.patient_hash);
  const setPatientNo = Recoil.useSetRecoilState(AppStore.assets.patient_no);
  const resetPages = Recoil.useResetRecoilState(AppStore.navigation.pages('App'));

  const onLogout = React.useCallback((success, data, parameters) => {
    setLogined(() => false);
    setDoctorInfo(() => ({}));
    setPatientList(() => []);
    setPatientHash(() => ({}));
    setPatientNo(() => null);
    resetPages();
  }, [resetPages, setDoctorInfo, setLogined, setPatientHash, setPatientList, setPatientNo]);
  return onLogout;
}
